import React from 'react';
export const spinnerSize = {
    xsmall: 14,
    small: 16,
    medium: 20,
    large: 24,
    iconOnly: 20
};
const calloutSizeMap = {
    large: 'medium',
    medium: 'small',
    small: 'xsmall',
    xsmall: 'xsmall',
    iconOnly: 'iconOnly'
};
export const downsizeForCallout = (size)=>calloutSizeMap[size];
